"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var mobx_react_1 = require("mobx-react");

var shared_1 = require("../../../../../shared");

var RowHeadCell_meta_1 = require("./RowHeadCell.meta");

var TableComponentBase_1 = require("../TableComponentBase");

var Superscript_1 = __importDefault(require("../../styledComponents/Superscript"));

var Tooltip_1 = __importDefault(require("../../../Tooltip"));

var CellValue_1 = __importDefault(require("../CellValue"));

var Translate_1 = require("../../../Translate/Translate");

var RowHeadCell =
/** @class */
function (_super) {
  __extends(RowHeadCell, _super);

  function RowHeadCell(props) {
    var _this = _super.call(this, props) || this;

    _this.categoryKey = RowHeadCell_meta_1.ROW_HEAD_CELL_CATEGORY_KEY;
    _this.componentKey = RowHeadCell_meta_1.ROW_HEAD_CELL_COMPONENT_KEY;
    return _this;
  }

  Object.defineProperty(RowHeadCell.prototype, "parentComponentKey", {
    get: function get() {
      return RowHeadCell_meta_1.ROW_HEAD_CELL_PARENT_COMPONENT_KEY;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(RowHeadCell.prototype, "tableEventsKey", {
    get: function get() {
      return 'rowHeadCell';
    },
    enumerable: true,
    configurable: true
  });

  RowHeadCell.prototype.render = function () {
    var _a = this.props,
        children = _a.children,
        configuration = _a.configuration,
        componentStyle = _a.componentStyle,
        componentStyleProps = _a.componentStyleProps,
        table = _a.table,
        cellValue = _a.cellValue,
        column = _a.column,
        columnIndex = _a.columnIndex,
        row = _a.row,
        rowIndex = _a.rowIndex,
        otherProps = __rest(_a, ["children", "configuration", "componentStyle", "componentStyleProps", "table", "cellValue", "column", "columnIndex", "row", "rowIndex"]);

    var superscripts = this.table.logic.getCellSuperscripts(column, row);
    var tooltipProps = this.getTooltipRowProps(row, column);
    var events = this.getEvents(this.eventsForElement, row, rowIndex, column, columnIndex, cellValue);
    var cellValueComponent = react_1.default.createElement(CellValue_1.default, {
      table: this.table,
      cellValue: cellValue,
      column: column
    });

    if (!superscripts && !tooltipProps) {
      return react_1.default.createElement("th", __assign({}, events, otherProps, {
        scope: "row"
      }), cellValueComponent);
    }

    return react_1.default.createElement(Translate_1.TranslationContext.Consumer, null, function (translationContext) {
      var ariaProps = {}; // set up aria-label so that VO announces just the cellValue instead of the tooltips as well

      ariaProps['aria-label'] = translationContext.translate(cellValue);
      return react_1.default.createElement("th", __assign({
        colSpan: column.colSpan
      }, events, otherProps, {
        scope: "row"
      }), react_1.default.createElement("div", __assign({}, ariaProps), cellValueComponent, superscripts && react_1.default.createElement(Superscript_1.default, null, superscripts.join(',')), tooltipProps && tooltipProps.map(function (props, index) {
        return react_1.default.createElement(Tooltip_1.default, __assign({
          key: "tooltip_" + index
        }, props));
      })));
    });
  };

  RowHeadCell = __decorate([mobx_react_1.observer], RowHeadCell);
  return RowHeadCell;
}(TableComponentBase_1.TableComponentBase);

exports.RowHeadCell = RowHeadCell;
exports.default = shared_1.InjectedStyledComponent(RowHeadCell, RowHeadCell_meta_1.ROW_HEAD_CELL_CATEGORY_KEY, RowHeadCell_meta_1.ROW_HEAD_CELL_PARENT_COMPONENT_KEY, [RowHeadCell_meta_1.ROW_HEAD_CELL_COMPONENT_KEY]);